<template>
  <div>
    <v-navigation-drawer 
      v-model="$store.state.usermenu" 
      width="200" 
      app 
      right 
      temporary>
      <v-layout 
        column 
        justify-space-between 
        fill-height>
        <v-list>
          <v-list-tile @click="select('Käyttäjä')">
            <v-list-tile-title>
              -
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile 
            v-for="item in $store.state.users" 
            :key="item.index" 
            @click="select(item)">
            <v-list-tile-title>
              {{ item }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-btn 
          color="primary" 
          @click="$store.state.logoutdialog = true">Kirjaudu ulos</v-btn>
      </v-layout>
    </v-navigation-drawer>
    <dialog-logout />
  </div>
</template>
<script>
export default {
	data() {
		return {
			menu: false
		}
	},
	methods: {
		select(user) {
			this.$store.state.selected_user = user
			this.$cookie.set('varasto-otto-user', user)
			this.$store.state.usermenu = false
		}
	}
}
</script>
